import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateMarksAndNumbersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateMarksAndNumbersInput;
}>;

export type UpdateMarksAndNumbersMutationResult = { __typename?: 'Mutation' } & {
  updateMarksAndNumbers: { __typename?: 'UpdateMarksAndNumbersPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateMarksAndNumbersDocument = /*#__PURE__*/ gql`
  mutation updateMarksAndNumbers($input: UpdateMarksAndNumbersInput!) {
    updateMarksAndNumbers(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateMarksAndNumbersMutation__
 *
 * To run a mutation, you first call `useUpdateMarksAndNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarksAndNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarksAndNumbersMutation, { data, loading, error }] = useUpdateMarksAndNumbersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarksAndNumbersMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMarksAndNumbersMutationResult, UpdateMarksAndNumbersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateMarksAndNumbersMutationResult, UpdateMarksAndNumbersMutationVariables>(
    UpdateMarksAndNumbersDocument,
    options
  );
}
export type UpdateMarksAndNumbersMutationHookResult = ReturnType<typeof useUpdateMarksAndNumbersMutation>;
